// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1Jrtt","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__skvY6"};